export default __webpack_public_path__ + "7b44ef2bddd7a0ff80f55e86902cc89c.png";